/**
 * Constants an other symbols specific to the Box Lookup feature.
 */

const LookupValueOrigin = {
  // Indicates that the lookup value originates from a generic barcode scan
  ScannedBarcode: 0,
  Data: 1,
};

export default {
  LookupValueOrigin,
};
